import React from 'react';

// ///////////////// LAZY LOAD ////////////////////////////
import Loadable from 'react-loadable';
import Loading from './common_components/Loading';

const AsyncChatPage = Loadable({
  loader: () => import('./chat_components/Main'),
  loading: Loading
});
// ///////////////////////////////////////////////////////

export default props => <AsyncChatPage {...props} />;
